import { QueryClient } from "@tanstack/react-query";

/** Default cache: 5 min fresh, 30 min in memory after unused. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
